import React, { useState } from 'react';
import styled from 'styled-components';
import { getIn } from 'seamless-immutable';
import StockAlert from '@catalogo/ui-americanas-mobile-offers-box/src/stock-alert';
import BuyButton from '@catalogo/ui-americanas-mobile-buy-button';
import BuyAme from '@catalogo/ui-americanas-mobile-buy-ame';
import WeddingList from '@catalogo/ui-americanas-mobile-wedding-list';
import {
  getLimit,
  showSelector,
} from '@catalogo/ui-americanas-mobile-product-main-area/src/components/product-offer/helpers';
import TheftProtection from '@catalogo/ui-americanas-desktop-theft-protection';
import withServicesPDP from '@catalogo/service-americanas-product/src/hocs/services-pdp';
import compose from 'lodash/fp/compose';
import { withMetrics } from '@catalogo/core-metrics';
import SelectorQuantity from './selector-quantity';

export const BuyArea = ({
  config,
  currentSku,
  product,
  cookies,
  page,
  history,
  experiment,
  discountProgressiveExperiment,
  breadcrumb,
  parsedQs,
  location,
  servicesPDP,
}) => {
  const [selectQuantityWasUsed, setSelectQuantityWasUsed] = useState(false);
  const offer = getIn(currentSku, ['offers', 'result', '0']);
  const isBoleto = getIn(offer, ['bestPaymentOption', 'type']) === 'BOLETO';
  const isO2O = getIn(offer, ['seller', 'id']) === '33014556000196';
  const hasFeatures = getIn(page, ['components', 'page-config', 'features'], '').split(', ');
  const isBuyAmeEnabled = hasFeatures.includes('BUY_AME');
  const isGiftVoucher = getIn(product, ['isGiftVoucher'], false);
  const isB2WSeller = offer?.seller?.id === config.sellerId;
  const weddingList = !!getIn(cookies, ['listId'], '') && isB2WSeller;
  const enableAme = !weddingList && !isBoleto && !isO2O && isBuyAmeEnabled && !isGiftVoucher;
  const { salesPrice, quantity } = offer ?? {};
  const limit = getLimit(quantity);
  const showUISelector = showSelector(salesPrice, limit);

  return (
    <BuyButtonWrapper>
      <StockAlert offer={offer} currentSku={currentSku} product={product} />
      {showUISelector && (
        <SelectorQuantity history={history} limit={limit} setSelectQuantityWasUsed={setSelectQuantityWasUsed} />
      )}
      <TheftProtection {...servicesPDP?.infoForComponent} />
      <BuyButton
        isO2O={isO2O}
        product={product}
        currentSku={currentSku}
        categoryUrl={breadcrumb?.[0]?.url}
        productId={getIn(product, ['id'])}
        isPreSale={getIn(product, ['isPreSale'])}
        experiment={experiment?.CAT_021_VARIACOES_SKU}
        discountProgressiveExperiment={discountProgressiveExperiment}
        selectQuantityWasUsed={selectQuantityWasUsed}
        routerProps={{ parsedQs, location, params: { id: getIn(product, ['id']) } }}
        servicePDPinfoForWarranty={servicesPDP?.infoForWarranty}
        history={history}
      />
      {weddingList && <WeddingList currentSku={currentSku} isDesk />}
      {enableAme && <BuyAme />}
    </BuyButtonWrapper>
  );
};

/* istanbul ignore next */
const BuyButtonWrapper = styled.div`
  border-top: 0px;
  padding-top: 24px;
`;

export default compose(withMetrics, withServicesPDP)(BuyArea);
